import { render, staticRenderFns } from "./blueheader.vue?vue&type=template&id=2c4560f3&scoped=true"
import script from "./blueheader.vue?vue&type=script&lang=js"
export * from "./blueheader.vue?vue&type=script&lang=js"
import style0 from "./blueheader.vue?vue&type=style&index=0&id=2c4560f3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4560f3",
  null
  
)

export default component.exports